import { get } from "lodash-es";
import { Asset } from "./Asset";
import { MESApiService } from "@dexteel/mesf-core";

export const getAssets = async (signal?: AbortSignal) => {
	const apiService = new MESApiService();

	const resp = await apiService.callV2("[MES].[GetAssets]", [], signal);

	if (resp.ok) {
		return get(resp, "data.tables[0].rows", []) as Asset[];
	} else {
		throw new Error(resp.message || "Error fetching assets");
	}
};
